import { fmtMoney, fmtDate } from '../../utils/constants';

export default function ArchiveView({ contracts, onOpen }) {
  const archived = (contracts || []).filter(c => c.archived);

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: 'var(--navy-900)', marginBottom: 4 }}>Archive</h1>
        <p style={{ fontSize: 13.5, color: 'var(--slate-500)' }}>
          {archived.length} completed contract{archived.length !== 1 ? 's' : ''} — read-only
        </p>
      </div>

      {archived.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 24px', color: 'var(--slate-400)' }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>📁</div>
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>No archived contracts yet</div>
          <div style={{ fontSize: 13.5 }}>Contracts appear here after the handoff & closure process is complete.</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {archived.map(c => (
            <div
              key={c.id}
              onClick={() => onOpen(c)}
              style={{
                background: 'var(--white)', borderRadius: 'var(--r-lg)',
                border: '1.5px solid var(--slate-200)', padding: '16px 20px',
                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 16,
                opacity: 0.85,
                transition: 'opacity 0.15s, box-shadow 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.opacity = '1'}
              onMouseLeave={e => e.currentTarget.style.opacity = '0.85'}
            >
              {/* Avatar */}
              <div style={{
                width: 44, height: 44, borderRadius: 10, flexShrink: 0,
                background: 'var(--slate-200)', display: 'flex', alignItems: 'center',
                justifyContent: 'center', fontWeight: 800, fontSize: 14, color: 'var(--slate-500)',
              }}>
                {(c.title || 'C').slice(0, 2).toUpperCase()}
              </div>

              {/* Info */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 14.5, color: 'var(--navy-800)', marginBottom: 2 }}>
                  {c.title || 'Untitled Contract'}
                </div>
                <div style={{ fontSize: 12.5, color: 'var(--slate-500)' }}>
                  {fmtMoney(c.budget)} · {c.procMethod || 'No method'} · Archived {fmtDate(c.archivedAt)}
                </div>
              </div>

              {/* Badges */}
              <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                <span style={{
                  fontSize: 10.5, fontWeight: 700, padding: '3px 8px', borderRadius: 99,
                  background: 'var(--slate-100)', color: 'var(--slate-500)',
                  border: '1px solid var(--slate-200)',
                }}>
                  📁 Archived
                </span>
                {c.isIT === 'yes' && (
                  <span style={{
                    fontSize: 10.5, fontWeight: 700, padding: '3px 8px', borderRadius: 99,
                    background: 'var(--blue-50)', color: 'var(--blue-600)',
                    border: '1px solid var(--blue-100)',
                  }}>IT</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
